module.exports = __webpack_public_path__ + "static/media/garage.b241adc0.svg";